// extracted by mini-css-extract-plugin
export var fileUpload = "_fm-1";
export var modalButton = "_fm-0";